import { useSelector } from 'react-redux';

import { subscriptionSelectors } from '../../../../store/modules/subscription';

const useCardUpdateState = () => {
  const updateCardData = useSelector(
    subscriptionSelectors.selectUpdateCardData
  );

  const isPending = useSelector(subscriptionSelectors.selectUpdateCardPending);
  const isError = useSelector(subscriptionSelectors.selectCardUpdateError);

  return !isError && !isPending ? updateCardData : null;
};

export default useCardUpdateState;
